export default {"src":"/_next/static/media/Supernode.e1080234.svg","height":32,"width":32};